// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2ewqU","right":"styles_right__31fhl"};